import { render, staticRenderFns } from "./PpeApplyRecordList.vue?vue&type=template&id=1c5f1f5d&"
import script from "./PpeApplyRecordList.vue?vue&type=script&lang=js&"
export * from "./PpeApplyRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports